import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CompassLogo } from "@/components/CompassLogo";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import Reperes from "@/pages/Reperes";
import Budget from "@/pages/Budget";
import Reseau from "@/pages/Reseau";
import Demarches from "@/pages/Demarches";
import Astuces from "@/pages/Astuces";
import Communaute from "@/pages/Communaute";
import LegalPage from "@/pages/LegalPage";
import LegalGate from "@/pages/LegalGate";
import Onboarding from "@/pages/Onboarding";
import ProfileCompletion from "@/pages/ProfileCompletion";

function FullLoader() {
  return (
    <div className="min-h-screen grid place-items-center bg-paper">
      <CompassLogo size={48} className="animate-spin" />
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/" replace />;
  if (user.cgu_needs_acceptance) return <LegalGate />;
  if (!user.onboarding_completed) return <Onboarding />;
  if (!user.profile_completed) return <ProfileCompletion />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (user) return <Navigate to="/app/reperes" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<PublicOnly><AuthPage /></PublicOnly>} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/legal/:doc" element={<LegalPage />} />
      <Route path="/app" element={<Protected><Layout /></Protected>}>
        <Route index element={<Navigate to="/app/reperes" replace />} />
        <Route path="reperes" element={<Reperes />} />
        <Route path="budget" element={<Budget />} />
        <Route path="reseau" element={<Reseau />} />
        <Route path="demarches" element={<Demarches />} />
        <Route path="astuces" element={<Astuces />} />
        <Route path="communaute" element={<Communaute />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
